import { Injectable } from '@angular/core';

import { IDeleteRechnungRequest, IDeleteRechnungResponse } from 'fa-kt.types';
import { DeleteCommandService } from 'pbc.angular';

@Injectable({
  providedIn: 'root',
})
export class DeleteRechnungCommandService extends DeleteCommandService<IDeleteRechnungRequest, IDeleteRechnungResponse> {
  readonly route = 'finanzen/rechnung';
}
